import Base from './condition-base'
import renderFields from './beacon.pug'

export default class Beacon extends Base
  Object.defineProperty this, "label", get: -> @t(".label")

  renderFields: renderFields
